export default __webpack_public_path__ + "static/media/jasmine.8fcafc60.svg";